/**
 * Constants for all display types
 * @module services/content/display-types
 */
import { Map, List } from 'immutable'
import {
  CONTENT_TYPE_PROMOTION,
  CONTENT_TYPE_SERIES,
  CONTENT_TYPE_VIDEO,
  CONTENT_TYPE_ARTICLE,
  CONTENT_TYPE_FAQ,
  CONTENT_TYPE_PRODUCT,
  CONTENT_TYPE_BONUS_PACKAGE,
  CONTENT_TYPE_SERVICE,
  CONTENT_TYPE_COURSE,
} from './content-types'

export const DISPLAY_TYPE_EVENT = 'event'
export const DISPLAY_TYPE_FITNESS = 'fitness'
export const DISPLAY_TYPE_GUIDE = 'guide'
export const DISPLAY_TYPE_NORMAL = 'normal'
export const DISPLAY_TYPE_YOGA = 'yoga'
export const DISPLAY_TYPE_RECIPE = 'recipe'
export const DISPLAY_TYPE_COURSE_LIGHT = 'course-light'
export const DISPLAY_TYPE_COURSE_DARK = 'course-dark'
export const DISPLAY_TYPE_COURSE_ASTROLOGY = 'course-astrology'

const standardOptions = List([
  Map({ label: 'Event', value: DISPLAY_TYPE_EVENT }),
  Map({ label: 'Fitness', value: DISPLAY_TYPE_FITNESS }),
  Map({ label: 'Guide', value: DISPLAY_TYPE_GUIDE }),
  Map({ label: 'Normal', value: DISPLAY_TYPE_NORMAL }),
  Map({ label: 'Yoga', value: DISPLAY_TYPE_YOGA }),
  Map({ label: 'Recipe', value: DISPLAY_TYPE_RECIPE }),
])
const DISPLAY_TYPE_BY_CONTENT_TYPE = Map({
  [CONTENT_TYPE_VIDEO]: standardOptions,
  [CONTENT_TYPE_SERIES]: standardOptions,
  [CONTENT_TYPE_ARTICLE]: standardOptions,
  [CONTENT_TYPE_PROMOTION]: List([Map({ label: 'Full Width Promo', value: 'full-width-promo' })]),
  [CONTENT_TYPE_FAQ]: List([Map({ label: 'FAQ', value: 'faq' })]),
  [CONTENT_TYPE_PRODUCT]: List([Map({ label: 'Product', value: 'product' })]),
  [CONTENT_TYPE_BONUS_PACKAGE]: List([Map({ label: 'Bonus Package', value: 'bonus-package' })]),
  [CONTENT_TYPE_SERVICE]: List([Map({ label: 'Service', value: 'service' })]),
  [CONTENT_TYPE_COURSE]: List([
    Map({ label: 'Course - Light', value: DISPLAY_TYPE_COURSE_LIGHT }),
    Map({ label: 'Course - Dark', value: DISPLAY_TYPE_COURSE_DARK }),
    Map({ label: 'Astrology', value: DISPLAY_TYPE_COURSE_ASTROLOGY }),
  ]),
})

export function getDisplayTypeOptions (contentType) {
  const options = DISPLAY_TYPE_BY_CONTENT_TYPE.get(contentType, List())
  return options.isEmpty()
    ? options
    : List([Map({ label: 'Please select a display type', value: '' })]).concat(options)
}

export function getDisplayTypes () {
  return standardOptions.map((o) => o.get('value')).toArray()
}
